import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RaceDaysAllDayItem {
    raceday_id?: number;
    day_real?: string;
    day_planned?: string;
    group_id?: number;
    group_name?: string;
    circuit_name?: string;
    icon?: string;
    icon_color?: string;
}

export interface RaceDaysAllSeasonItem {
    season_id?: number;
    season_name?: string;
    days?: RaceDaysAllDayItem[];
}

@Injectable()
export class RaceDaysAllService {
    private apiRaceDaysAllUrl = `${environment.apiBaseUrl}/api/raceDaysAll.php`;
    private apiRacesForDay = `${environment.apiBaseUrl}/api/racesGetAllForDay.php`;
    private apiNextRaceDay = `${environment.apiBaseUrl}/api/nextRaceDay.php`;

    constructor(private http: HttpClient) {}

    getRaceDaysAll(): Observable<RaceDaysAllSeasonItem[]> {
        return this.http.get<RaceDaysAllSeasonItem[]>(this.apiRaceDaysAllUrl);
    }

    getRacesForDay(raceday_id: number): Observable<any> {
        const params = new HttpParams().set('raceday_id', raceday_id);
        return this.http.get<any>(this.apiRacesForDay, { params });
    }

    getNextRaceDay(): Observable<any> {
        return this.http.get<any>(this.apiNextRaceDay);
    }
}